import styled from "@emotion/styled"

export const $ImageBlock = styled("div")`
  display: block;
  margin: 1em 0;
`
